import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import Drawer from "@material-ui/core/Drawer";

import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import { withRouter } from "react-router";
import { Api } from "../../utils/api";
import { AdminView } from "../../user_requests/components/admin_view.component";
import Element from "./components/element.component";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    marginBottom: "20px",
  },
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
  drawerButton: {
    marginLeft: 3,
    marginRight: 20,
  },
  nested: {
    paddingLeft: `${theme.spacing.unit * 2}px !important`,
  },
});

const ROUTES = {
  dashboard: {
    name: "Dashboard",
  },
  statistics: {
    name: "Estatísticas",
  },
  user_requests: {
    name: "Pedidos",
  },
  /* 'user_requests/per_day': {
    name: 'Pedidos Por Dia',
    sub: true
  }, */
  callsbooked_list: {
    name: "Agenda de Contatos",
  },
  visits_list: {
    name: "Visitas agendadas",
  },
  call_types: {
    name: "Tipificação de Chamadas",
  },
  establishments: {
    name: "Equipamentos",
  },
  entities: {
    name: "Entidades",
  },
  testimonials: {
    name: "Testemunhos",
    subOptions: {
      particular: {
        name: "Pessoais",
        sub: true,
      },
      professional: {
        name: "Profissionais",
        sub: true,
      },
    },
  },
  entity_groups: {
    name: "Grupos de Entidades",
    //sub: true
  },
  payments: {
    name: "Cobranças",
  },
  entity_invoices: {
    name: "Faturação",
  },
  requests_history: {
    name: "Histórico de Faturação",
  },
  logout: {
    name: "Logout",
  },
  invoices: {
    name: "Criar fatura",
    hidden: true,
  },
  credit_notes: {
    name: "Nota Crédito",
    hidden: true,
  },
  email_validator: {
    name: "Emails",
    hidden: true,
  },
};

class TopBar extends React.Component {
  state = {
    left: false,
  };

  constructor() {
    super();
    this.api = new Api();
    this.goTo = this.goTo.bind(this);
    this.titleFromLocation = this.titleFromLocation.bind(this);
    this.colorFromLocation = this.colorFromLocation.bind(this);
    this.logout = this.logout.bind(this);
  }

  closeDrawer = () => {
    this.setState({
      left: false,
    });
  };

  openDrawer = () => {
    this.setState({
      left: true,
    });
  };

  toggleDrawer = () => {
    if (this.state.left) {
      this.closeDrawer();
    } else {
      this.openDrawer();
    }
  };

  goTo(location) {
    this.props.history.push(location, this.state);
    this.closeDrawer();
  }

  logout() {
    this.api.logout();
    window.location.reload();
  }

  titleFromLocation() {
    const { location } = this.props;
    if (location.pathname) {
      const { pathname } = location;
      const tokens = pathname.split("/").filter((tok) => tok.length > 0);
      //return ROUTES[tokens[0]] ? ROUTES[tokens[0]].title : ROUTES[tokens[0]];
      return (ROUTES[tokens[0]] || ROUTES["user_requests"]).name;
    }

    return "LaresOnline";
  }

  colorFromLocation() {
    const { location } = this.props;
    if (location.pathname) {
      const { pathname } = location;
      const secondary =
        pathname.split("/").filter((tok) => tok.length > 0).length > 1;
      return secondary ? "secondary" : "primary";
    }

    return "primary";
  }

  render() {
    const { classes } = this.props;
    const sideList = (
      <div className={classes.list}>
        <div className="drawer-header">
          <IconButton
            onClick={this.toggleDrawer}
            className={classes.drawerButton}
            color="inherit"
            aria-label="Menu"
          >
            <MenuIcon />
          </IconButton>
          <img alt="logo" src="/logo.svg" />
        </div>
        <Divider />
        <List>
          {Object.keys(ROUTES).map(
            (route, idx) =>
              !ROUTES[route].hidden && (
                <Element
                  key={idx}
                  goTo={this.goTo}
                  button
                  route={route}
                  primary={ROUTES[route].name}
                  className={`${ROUTES[route].sub ? classes.nested : ""}`}
                  subOptions={ROUTES[route].subOptions}
                  classes={classes}
                />
              )
          )}
        </List>
      </div>
    );

    return (
      <>
        <Drawer anchor="left" open={this.state.left} onClose={this.closeDrawer}>
          <div tabIndex={0} role="button">
            {sideList}
          </div>
        </Drawer>
        <div className={classes.root}>
          <AppBar position="static">
            <Toolbar>
              <IconButton
                onClick={this.toggleDrawer}
                className={classes.menuButton}
                color="inherit"
                aria-label="Menu"
              >
                <MenuIcon />
              </IconButton>
              <Typography variant="h6" color="inherit" className={classes.grow}>
                {this.titleFromLocation()}
              </Typography>
              {this.api.loggedIn() && <AdminView image adminId={"me"} />}
            </Toolbar>
          </AppBar>
        </div>
      </>
    );
  }
}

TopBar.propTypes = {
  classes: PropTypes.object.isRequired,
};

const TopBarWithStyles = withStyles(styles, { withTheme: true })(TopBar);

export default withRouter(TopBarWithStyles);
